import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {requestAdminOrganizationList} from '../../actions/action_admin_organization';
import {requestCreateAdminUser} from '../../actions/action_admin_user';
import Title from '../Title';
import UserCreateForm from './UserCreateForm';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';

class UserCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.props.requestAdminOrganizationList();
    }

    componentDidUpdate(prevProps) {
        if (this.props.submitting !== prevProps.submitting && !this.props.submitting && this.props.item) {
            this.props.history.push('/admin/users');
        }
    }

    handleSubmit(data) {
        const values = Object.assign({enabled: true}, data);
        delete values.password2;
        this.props.requestCreateAdminUser(values);
    }

    render() {
        const {organizations, loading, error, submitting} = this.props;
        return (
            <div className="row">
                <div className="col-md-2 col-12">
                    <Link className="btn btn-outline-primary btn-sm" to="/admin/users">
                        <Icon icon="arrow_left" /> <FormattedMessage {...messages.buttons.back} />
                    </Link>
                </div>
                <div className="col-md-8 col-12">
                    <Title><FormattedMessage {...messages.admin.users.create} /></Title>
                    <UserCreateForm error={error} onSubmit={this.handleSubmit} loading={loading || submitting} organizations={organizations} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.admin.users.item,
        organizations: state.admin.organizations.items,
        loading: state.admin.users.loading || state.admin.organizations.loading,
        error: state.admin.users.error,
        submitting: state.admin.users.submitting,
    };
};

export default connect(mapStateToProps, {requestCreateAdminUser, requestAdminOrganizationList})(UserCreate);
